import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ActionEventHandler, ModifiedActionStatus } from 'apps/website/src/app/utils/enums';
import { DataFieldType } from '../../../common-ui/table-ui/table-ui.component';

@Component({
  selector: 'intrasense-table-drop-text-actions',
  templateUrl: './table-drop-text-actions.component.html',
  styleUrls: ['./table-drop-text-actions.component.scss']
})
export class TableDropTextActionsComponent implements OnInit {
  @Input('row') row: any;
  @Input('item') item: any;
  @Input('index') i: any;
  @Output() onBtnClick = new EventEmitter();
  ActionEventHandler = ActionEventHandler;
  ModifiedActionStatus = ModifiedActionStatus;
  
  constructor() { }

  ngOnInit(): void {
  }


  click(index: number, type: DataFieldType, actionEvent: string) {
    console.log(actionEvent)
    this.onBtnClick.emit({index$: index, type$: type, actionEvent$: actionEvent})
  }

  btnClick(event: any) {
    this.onBtnClick.emit({index$: event.index$, type$: event.type$, actionEvent$: event.actionEvent$})
  }
}
